import React from 'react';
import {PropTypes} from 'prop-types';
import {BaseFormComponent} from '../../shared/baseFormComponent';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';
import {ButtonBusyIndicatorComponent} from '../../shared/buttonBusyIndicatorComponent';
import {SetFocusOnFirstFormControl, AssignProperties, DisplaySuccessMessage, MakeApiCall, PrepareError, CreateTimer, PreventDOMLock} from '../../shared/utils';

const RECOVER_ACTION = {
    NONE: 0,
    RECOVER: 1
}

export class RecoverPasswordFormComponent extends BaseFormComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            action: RECOVER_ACTION.NONE,
            errors: null, 
            reCaptchaAPILoaded: false,
            formData: {Email: props.email}
        };
        this.doRecovery = this.doRecovery.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.getReCaptchaToken = this.getReCaptchaToken.bind(this);
        this.reCaptchaTimer = CreateTimer(200);
        this.checkReCaptchaLoaded = this.checkReCaptchaLoaded.bind(this);

        this._valueHandler.onBlurOptions = {
            'Email': BaseFormComponent.EmailOptions
        };
    }

    checkReCaptchaLoaded() {
        const self = this;

        self.reCaptchaTimer.stop();

        const grecaptchaApi = window['grecaptcha'];
        if (Boolean(grecaptchaApi) && !self.state.reCaptchaAPILoaded) {
            grecaptchaApi.ready(
                () => {
                    if (self._isMounted) {
                        self.setState({reCaptchaAPILoaded: true});
                    }
                }
            )
        }

        if (!Boolean(grecaptchaApi) && self._isMounted) {
            self.reCaptchaTimer.start();
        }
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;

        if (Boolean(self.props.isSetFocus)) {
            SetFocusOnFirstFormControl(self, true);
        }

        self.reCaptchaTimer.onTimer = self.checkReCaptchaLoaded;
        self.checkReCaptchaLoaded();
    }

    componentWillUnmount() {
        this._isMounted = false;
        self.reCaptchaTimer.stop();
    }

    getReCaptchaToken() {
        const self = this;
        const {reCaptchaSiteKey} = self.props;
        if (!Boolean(reCaptchaSiteKey)) {
            return Promise.resolve('');
        }

        const grecaptchaApi = window['grecaptcha'];
        if (!self.state.reCaptchaAPILoaded) {
            return Promise.reject('ReCAPTCHA API was not loaded.');
        }
        else {
            return new Promise((resolve, reject) => {
                try {
                    grecaptchaApi.execute(reCaptchaSiteKey, {action: 'homepage'})
                        .then(token => {
                            resolve(token);
                        });
                }
                catch(error) {
                    //reject(error);
                    reject('ReCAPTCHA API error.');
                }
            })
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const self = this;

        PreventDOMLock(self.doRecovery);
    }

    doRecovery() {
        const self = this;
        const {recoverPasswordApiUrl, verificationToken} = self.props;

        if (!Boolean(recoverPasswordApiUrl) || !self._isMounted) {
            return;
        }

        new Promise(resolve => {
            self.setState({action: RECOVER_ACTION.RECOVER, errors: null}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return self.getReCaptchaToken();
            }
        })
        .then(token => {
            if (self._isMounted) {
                const data = {...self.state.formData, ReCaptchaToken: token};

                return MakeApiCall(
                    $.post(
                        {
                            url: recoverPasswordApiUrl,
                            headers: {RequestVerificationToken: verificationToken},
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ));
            }
        })
        .then(responseData => {
            if (self._isMounted) {
                DisplaySuccessMessage(responseData.SuccessMessage);
                self.setState({action: RECOVER_ACTION.NONE});
            }
        })
        .catch(errors => {
            if (self._isMounted) {
                self.setState({action: RECOVER_ACTION.NONE, errors: PrepareError(errors)});
            }
        });
    }

    render() {
        const self = this;
        const {action, errors, formData, reCaptchaAPILoaded} = self.state;
        const {reCaptchaSiteKey} = self.props;
        const isDisabled = action !== RECOVER_ACTION.NONE;
        const strings = self.strings;

        const isSubminAllowed = !Boolean(reCaptchaSiteKey) || reCaptchaAPILoaded;

        return (
            <div>
                <div className="text-center">
                    <ErrorsBlockComponent errors={errors} unstyled excludedErrors="Email" />
                </div>
                <div className="row">
                    <div className="m-auto col-xl-5 col-lg-6 col-md-8 col-sm-10">
                        <form onSubmit={isSubminAllowed ? self.handleSubmit : null}>
                            <div className="form-group newstyle">
                                <div className={'input-group ' + self.getControlClass('Email', errors)} disabled={isDisabled}>
                                    <input 
                                        type="text" 
                                        id="email"
                                        name="Email" 
                                        autoComplete="email"
                                        onChange={self.handleInputChange}
                                        onBlur={self.handleInputChange}
                                        className={'form-control ' + self.getControlClass('Email', errors)} 
                                        value={formData.Email} 
                                        disabled={isDisabled} 
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text"><span className="sbkico-envelope"/></span>
                                    </div>
                                    <label htmlFor="email"><span className="text-truncate">{strings.F_Email}</span></label>
                                    <div className="invalid-feedback" dangerouslySetInnerHTML={{ __html: self.getControlError('Email', errors) }} />
                                </div>
                            </div>
                            <div className="form-group form-buttons d-flex justify-content-center">
                                {isSubminAllowed &&
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary newstyle" 
                                        disabled={isDisabled}
                                    >
                                        {strings.BTN_SendRecoveryEmail}<ButtonBusyIndicatorComponent visible={action == RECOVER_ACTION.RECOVER} />
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );    
    }
}
RecoverPasswordFormComponent.propTypes = {
    strings: PropTypes.object,
    verificationToken: PropTypes.string.isRequired,
    isSetFocus: PropTypes.bool,
    email: PropTypes.string,
    recoverPasswordApiUrl: PropTypes.string.isRequired,
    reCaptchaSiteKey: PropTypes.string,
}
RecoverPasswordFormComponent.defaultProps = {
    strings: {
        PH_Email: 'Email',
        F_Email: 'Email',
        BTN_SendRecoveryEmail: 'Send recovery email'
    },
    isSetFocus: false,
    email: '',
    password: ''
}
